"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\n\t&:checked + ", " {\n\t\tbackground: ", ";\n\t}\n\n\t&:checked + ", " > ", " {\n\t\tbackground: white;\n\t\ttransform: translateX(24px);\n\t}\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tvertical-align: middle;\n\tmargin-right: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: 100px;\n\twidth: 56px;\n\theight: 32px;\n\tdisplay: inline-block;\n\tpadding: 0;\n\tvertical-align: middle;\n\tbox-shadow: ", ";\n\tcursor: ", ";\n\tbackground: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\theight: 32px;\n\twidth: 32px;\n\tborder-radius: 100%;\n\tbackground: white;\n\ttransition: transform 0.2s ease;\n\tbox-shadow: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Marker = _styledComponents.default.span(_templateObject(), _vars.default.boxShadow);

Marker.displayName = 'Marker';

var Track = _styledComponents.default.span(_templateObject2(), _vars.default.insetboxShadow, function (props) {
  return props._disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props._disabled ? _colors.default.disabledBackground : 'white';
});

Track.displayName = 'Track';

var PromptText = _styledComponents.default.span(_templateObject3(), _spacing.default.s2);

PromptText.displayName = 'PromptText';

var Container = _styledComponents.default.label(_templateObject4());

Container.displayName = 'Container';

var Input = _styledComponents.default.input(_templateObject5(), Track, _colors.default.success, Track, Marker);

Input.displayName = 'Input';

var Switch = function Switch(_ref) {
  var id = _ref.id,
      name = _ref.name,
      disabled = _ref.disabled,
      checked = _ref.checked,
      onChange = _ref.onChange,
      label = _ref.label,
      gaAction = _ref.gaAction,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "name", "disabled", "checked", "onChange", "label", "gaAction"]);

  var checkedProp = onChange ? {
    checked: checked
  } : {
    defaultChecked: checked
  };
  return _react.default.createElement(Container, {
    htmlFor: id
  }, label && _react.default.createElement(PromptText, null, label), _react.default.createElement(Input, _extends({
    type: "checkbox",
    id: id,
    name: name,
    disabled: disabled,
    "data-track-action": gaAction,
    "data-track-value": "on",
    onChange: onChange
  }, checkedProp, props)), _react.default.createElement(Track, {
    _disabled: disabled,
    "data-testid": "checkbox-container"
  }, _react.default.createElement(Marker, null)));
};

Switch.displayName = 'Switch';
Switch.propTypes = {
  id: _propTypes.string.isRequired,
  checked: _propTypes.bool.isRequired,
  name: _propTypes.string.isRequired,
  disabled: _propTypes.bool,
  label: _propTypes.string,
  gaAction: _propTypes.string,
  onChange: _propTypes.func
};
Switch.defaultProps = {
  gaAction: '',
  disabled: false,
  label: null,
  onChange: undefined
};
var _default = Switch;
exports.default = _default;